'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectToNextStep = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.doRedirectToNextStep = doRedirectToNextStep;
exports.watchSignupCardSagas = watchSignupCardSagas;

var _reactRouterRedux = require('react-router-redux');

var _effects = require('redux-saga/effects');

var _pathToPurchaseHelper = require('helpers/pathToPurchaseHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doRedirectToNextStep),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchSignupCardSagas);

var redirectToNextStep = exports.redirectToNextStep = function redirectToNextStep(path) {
  return {
    type: 'SIGNUP_CARD_REDIRECT_TO_NEXT_STEP',
    path: path
  };
};

function doRedirectToNextStep(_ref) {
  var path = _ref.path;
  return _regenerator2.default.wrap(function doRedirectToNextStep$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_pathToPurchaseHelper.setPathToPurchaseTest);

        case 2:
          _context.next = 4;
          return (0, _effects.put)((0, _reactRouterRedux.push)(path));

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function watchSignupCardSagas() {
  return _regenerator2.default.wrap(function watchSignupCardSagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, redirectToNextStep().type, doRedirectToNextStep);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}